import { createContext } from 'react'

const EntryKeyContext = createContext(null)

const EntryKeyContextProvider = ({ children, value }) => {
  return (
    <EntryKeyContext.Provider value={value}>
      {children}
    </EntryKeyContext.Provider>
  )
}

export { EntryKeyContext, EntryKeyContextProvider }
